module.exports = __webpack_public_path__ + "img/play.9b3a9db3.svg";